import { Controller } from "@hotwired/stimulus"
import { deserializeFromLocalStorage, serializeToLocalStorage } from "~/helpers/local_storage_helpers"
import * as bootstrap from "bootstrap"
import { isMediaBreakpointUp } from "~/helpers/boostrap_helpers"

const STORAGE_KEY = "nuggit_sidebar_open"
const COLLAPSED_CLASS = "sidebar-collapsed"
const DEFAULT_BREAKPOINT = "md"

// Connects to data-controller="sidebar-controller"
export default class SidebarController extends Controller<HTMLElement> {
  initialize() {
    const isOpen = deserializeFromLocalStorage<boolean>(STORAGE_KEY) ?? true

    if (isMediaBreakpointUp(DEFAULT_BREAKPOINT)) {
      if (isOpen) {
        this.open({ updateStorage: false })
      } else {
        this.close({ updateStorage: false })
      }
    }
  }

  toggle() {
    if (this.#isShown()) {
      this.close()
    } else {
      this.open()
    }
  }

  open({ updateStorage = true } = {}) {
    this.element.classList.remove(COLLAPSED_CLASS)
    if (!isMediaBreakpointUp(DEFAULT_BREAKPOINT)) {
      this.#instance().show()
    }

    if (updateStorage) serializeToLocalStorage(STORAGE_KEY, true)
  }

  close({ updateStorage = true } = {}) {
    if (isMediaBreakpointUp(DEFAULT_BREAKPOINT)) {
      this.element.classList.add(COLLAPSED_CLASS)
    } else {
      this.element.classList.remove(COLLAPSED_CLASS)
      this.#instance().hide()
    }

    if (updateStorage) serializeToLocalStorage(STORAGE_KEY, false)
  }

  #instance() {
    return bootstrap.Offcanvas.getOrCreateInstance(this.element)
  }

  #isShown() {
    return this.element.classList.contains("show")
      || (isMediaBreakpointUp(DEFAULT_BREAKPOINT) && !this.element.classList.contains("sidebar-collapsed"))
  }
}
